/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InputField } from '../InputField';
import { PasswordField } from '../PasswordField';
import { Label } from '../Label';
import { ErrorMsg } from '../ErrorMsg';
import { OtpInput } from '../OtpInput';


/**
 * TextField component renders a label, input or password field, and error message.
 *
 * @param {object} props - Component props
 * @param {string} props.name - The name of the field
 * @param {string} [props.label=null] - The label for the field
 * @param {object} [props.form={}] - The form object containing React Hook Form methods
 * @param {string} [props.type='text'] - The type of the input field
 * @returns {JSX.Element}
 */
const TextField = ({
  name,
  label = null,
  type = 'text',
  ...props
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  /**
   * Renders the appropriate input component based on the provided type
   */
  const renderInputComponent = () => {
    if (type.includes('password')) {
      return (
        <PasswordField
          name={name}
          createPassword={type === 'create-password'}
          {...props}
        />
      );
    }

    if (type === 'one-time-code') {
      return (
        <OtpInput
          name={name}
          pushPasswordManagerStrategy="none"
          {...props}
        />
      );
    }

    return (
      <InputField
        name={name}
        type={type}
        {...props}
      />
    );
  };

  return (
    <>
      <Label
        name={name}
        label={label}
      />
      {renderInputComponent()}
      <ErrorMsg message={errors[name]?.message} />
    </>
  );
};

export { TextField };
